// 本地静态数据服务。
// 数据随网站部署，不依赖 AWS、Lambda 或其他远程数据库。

class ApiService {
  constructor() {
    this.jsonSources = {
      timeline: "/data/timeline.json",
      photographers: "/data/photographers.json",
    };

    this.stats = {
      staticJsonSuccess: 0,
      totalRequests: 0,
    };
  }

  async fetchJson(dataType) {
    this.stats.totalRequests++;

    const url = this.jsonSources[dataType];
    if (!url) {
      throw new Error(`Unknown static data type: ${dataType}`);
    }

    try {
      const startTime = Date.now();
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`Static JSON request failed: ${response.status}`);
      }

      const data = await response.json();
      const responseTime = Date.now() - startTime;

      if (!Array.isArray(data) || data.length === 0) {
        throw new Error("Invalid static JSON data format");
      }

      this.stats.staticJsonSuccess++;

      return {
        data,
        source: "static-json",
        responseTime,
        itemCount: data.length,
        timestamp: new Date().toISOString(),
      };
    } catch (error) {
      console.error(`Failed to load static ${dataType} data:`, error);
      throw error;
    }
  }

  async getTimeline() {
    return this.fetchJson("timeline");
  }

  async getPhotographers() {
    return this.fetchJson("photographers");
  }

  getStats() {
    return { ...this.stats };
  }
}

export const apiService = new ApiService();

export const getTimeline = () => apiService.getTimeline();
export const getPhotographers = () => apiService.getPhotographers();
export const getApiStats = () => apiService.getStats();

// 保留旧调试接口的兼容性；静态数据模式下无需重置失败状态。
export const resetApiFailures = () => undefined;
